import { render, staticRenderFns } from "./Legenda.vue?vue&type=template&id=3c34aac4&lang=pug"
import script from "./Legenda.vue?vue&type=script&lang=js"
export * from "./Legenda.vue?vue&type=script&lang=js"
import style0 from "./Legenda.vue?vue&type=style&index=0&id=3c34aac4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports